module.exports = __webpack_public_path__ + "img/enabled.4f5a46cb.svg";